import { createContext, type ReactNode, useContext, useState } from "react";

interface SidebarContextType {
	collapsed: boolean;
	toggle: () => void;
}

const SidebarContext = createContext<SidebarContextType | undefined>(undefined);

export const SidebarProvider = ({ children }: { children: ReactNode }) => {
	const [collapsed, setCollapsed] = useState(false);
	const toggle = () => setCollapsed((prev) => !prev);

	return (
		<SidebarContext.Provider value={{ collapsed, toggle }}>
			{children}
		</SidebarContext.Provider>
	);
};

export const useSidebar = () => {
	const context = useContext(SidebarContext);
	if (context === undefined) {
		throw new Error("useSidebar must be used within a SidebarProvider");
	}
	return context;
};
